import { DynamicFormAnswer } from '@api_patient/dynamic_forms_api.service';
import { CellulaFormSubmitData } from '@cellula/react';
import type { QuestionApiModel } from '@visiba/api-vcs-client-v2';
import { FormQuestionBase } from './_form_question_base';

export class FormQuestionTypeMultiline extends FormQuestionBase {
	public readonly type = 'Multiline';
	public defaultValue: string | undefined = undefined;

	constructor(question: QuestionApiModel) {
		super(question);
	}

	// TODO: Use this when not injected anymore...
	// public override getAnswer(formElements: FormElements<string>): AnswerApiModel {
	public getAnswer(pageData: CellulaFormSubmitData): DynamicFormAnswer {
		// public override getAnswer(formElements: FormElements<string>): AnswerApiModel {
		const formValue = pageData[this.id] ?? null;

		return this.createAnswerApiModel({
			stringValue: formValue,
		});
	}

	// TODO: Use this when not injected anymore...
	// public override setDefault(allAnswers: Readonly<AnswerApiModel[]>): void {
	public setDefault(allAnswers: Readonly<DynamicFormAnswer[]>): void {
		const answer = allAnswers.find((answer) => answer.questionId === this.composeQuestionId());
		this.defaultValue = answer?.stringValue ?? undefined;
	}
}
